package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.silk.style.toModifier
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.di.koinGet
import io.horion.cv.styles.ProfileDescriptionStyle
import org.jetbrains.compose.web.css.px

@Composable
fun ProfileForm() {

    val cvViewModel = koinGet<CvViewModel>()
    val cvUiState = cvViewModel.cvUiState

    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(10.px)
    ) {
        RichTextDescription(
            label = "Description",
            value = cvUiState.data.profil ?: "",
            onValueChange = { html ->
                cvViewModel.updateProfil(html)
            },
            modifier = ProfileDescriptionStyle.toModifier()
        )
    }
}